/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import NavDropdown from "react-bootstrap/lib/NavDropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { withRouter } from "react-router-dom";
import { Icon, Image, Flag, Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  homeAction, resumeAction, livelistAction,
  liveListMatrixAction, graphicTopologyAction,
  tagAction, logAction, configAction,
  opticFiberAction, OpticFiberLogAction
} from "../../actions/changeActiveItemActions";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

class BootstrapMenuBar extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      languageKey: localStorage.getItem(Constants.LOCAL_STORAGE_KEY),
      monitoringStyle: { display: "block" },
      olmStyle: { display: "none" },
      language: UtilsInstance.getLanguageStringFromKey(
        Constants,
        Strings),
      isUpdatingLanguageDimmerActive: false
    };
  }

  handleSelect = (eventKey) => {
    switch (eventKey) {
      case "/":
        this.props.onChangeHome();
        this.props.history.push("/");
        break;
      case "/resume":
        this.props.onChangeResume();
        this.props.history.push("/resume");
        break;
      case "/livelist":
        this.props.onChangeLiveList();
        this.props.history.push("/livelist");
        break;
      case "/livelist-matrix":
        this.props.onChangeLiveListMatrix();
        this.props.history.push("/livelist-matrix");
        break;
      case "/graphic-topology":
        this.props.onChangeGraphicTopology();
        this.props.history.push("/graphic-topology");
        break;
      case "/optic-fiber":
        this.props.onChangeOpticFiber();
        this.props.history.push("/optic-fiber");
        break;
      case "/optic-fiber-log":
        this.props.onChangeOpticFiberLog();
        this.props.history.push("/optic-fiber-log");
        break;
      case "/log":
        this.props.onChangeLog();
        this.props.history.push("/log");
        break;
      case "/config":
        this.props.onChangeConfig();
        this.props.history.push("/login-handler");
        break;
      default:
        break;
    }
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  handleLanguageChange = (lang) => {
    this.sendLanguageData(lang);
  }

  sendLanguageData = (lang) => {
    this.setState({ isUpdatingLanguageDimmerActive: true }, () => {

      fetch(Constants.REQUEST_IP_ADDRESS + "language_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({ language: lang })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          localStorage.setItem(Constants.LOCAL_STORAGE_KEY, lang);
          window.location.reload();
        })
        .catch((error) => {
          alert(Strings.UNABLE_TO_ALTER_LANGUAGE + Strings.REASON_DP + error);
        })
        .finally(this.setState({ isUpdatingLanguageDimmerActive: false }));
    });
  }

  getOpticFiberNav = (isFiberProcessOn) => {
    if (!isFiberProcessOn) {
      return null;
    }

    return (
      <Nav pullLeft bsStyle="pills" onSelect={k => this.handleDropdownSelect(k)} activeKey={this.props.active}>
        <NavDropdown id="nav-drop" style={fontStyle} title={this.state.dropdownTitle}>
          <MenuItem eventKey="/drop-mon">{Strings.MONITORING}</MenuItem>
          <MenuItem eventKey="/drop-opticFiber">{Strings.OPTIC_FIBER}</MenuItem>
        </NavDropdown>
      </Nav>
    );
  }

  handleDropdownSelect = (eventKey) => {
    if (eventKey === "/drop-mon") {
      this.setState({
        dropdownTitle: Strings.MONITORING,
        monitoringStyle: {
          display: "block"
        },
        olmStyle: {
          display: "none"
        }
      }, () => {
        this.handleSelect("/resume");
      });
    }
    else if (eventKey === "/drop-opticFiber") {
      this.setState({
        dropdownTitle: Strings.OPTIC_FIBER,
        monitoringStyle: {
          display: "none"
        },
        olmStyle: {
          display: "block"
        }
      }, () => {
        this.handleSelect("/optic-fiber");
      });
    }
  }

  setMenuBarCurrentState = () => {
    const currentPath = this.props.history.location.pathname;
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (isFiberProcessOn) {
      if (currentPath.includes("/optic-fiber")) {
        this.setState({
          dropdownTitle: Strings.OPTIC_FIBER,
          monitoringStyle: { display: "none" },
          olmStyle: { display: "block" }
        });
      } else {
        this.setState({
          dropdownTitle: Strings.MONITORING,
          monitoringStyle: { display: "block" },
          olmStyle: { display: "none" }
        });
      }
    } else {
      this.setState({
        dropdownTitle: Strings.MONITORING,
        monitoringStyle: { display: "block" },
        olmStyle: { display: "none" }
      });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.setMenuBarCurrentState();
  }
  // ----------------- Lifecycle Methods ----------------
  render() {
    let activePage = { "activeItem": "/" + this.props.location.pathname.split("/")[1] };
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (activePage.activeItem === "/login"
      || activePage.activeItem === "/login-handler"
      || activePage.activeItem === "/report"
      || activePage.activeItem === "/change-login"
      || activePage.activeItem === "/tags"
      || activePage.activeItem === "/edit-gsd"
      || activePage.activeItem === "/blacklist"
      || activePage.activeItem === "/ethernet-config"
      || activePage.activeItem === "/wlan-config"
      || activePage.activeItem === "/ts-expert-config"
      || activePage.activeItem === "/optic-fiber-config") {
      activePage.activeItem = "/config";
    }

    const { activeItem } = activePage;

    return (
      <>
        <Navbar fluid defaultExpanded inverse collapseOnSelect style={menuStyle}>
          <Navbar.Header>
            <Navbar.Brand>
              <Image style={noBorderStyle} src={process.env.PUBLIC_URL + "/logo.png"} alt="TS Monitor Logo" href="/" size="tiny" />
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Navbar.Collapse>
            <Nav pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/"
                active={activeItem === "/"}>
                {Strings.TS_EXPERT}
              </NavItem>
            </Nav>
            
            {this.getOpticFiberNav(isFiberProcessOn)}

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/resume"
                active={activeItem === "/resume"}>
                {Strings.RESUME}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/livelist'
                active={activeItem === "/livelist"}>
                {Strings.LIVE_LIST}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/livelist-matrix'
                active={activeItem === "/livelist-matrix"}>
                {Strings.MATRIX}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/graphic-topology'
                active={activeItem === "/graphic-topology"}>
                {Strings.GRAPHIC_TOPOLOGY}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/log'
                active={activeItem === "/log"}>
                {Strings.LOG}
              </NavItem>
            </Nav>

            {isFiberProcessOn && (
              <Nav style={this.state.olmStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
                <NavItem
                  style={fontStyle}
                  eventKey="/optic-fiber"
                  active={activeItem === "/optic-fiber"}>
                  {Strings.OPTIC_FIBER}
                </NavItem>
              </Nav>
            )}

            {isFiberProcessOn && (
              <Nav style={this.state.olmStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
                <NavItem
                  style={fontStyle}
                  eventKey="/optic-fiber-log"
                  active={activeItem === "/optic-fiber-log"}>
                  {Strings.LOG}
                </NavItem>
              </Nav>
            )}

            <Nav pullRight bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>

              <NavDropdown
                role="menuitem"
                id="language-dropdown"
                eventKey={this.state.languageKey}
                title={this.state.language}
                onSelect={lang => this.handleLanguageChange(lang)}>

                <MenuItem
                  eventKey="pt">
                  <Flag name="br" />
                  {Strings.PORTUGUESE}
                </MenuItem>

                <MenuItem
                  eventKey="en">
                  <Flag name="us" />
                  {Strings.ENGLISH}
                </MenuItem>

                <MenuItem
                  eventKey="es">
                  <Flag name="es" />
                  {Strings.SPANISH}
                </MenuItem>

                {/* <MenuItem
                  eventKey="de">
                  <Flag name="de" />
                  {Strings.GERMAN}
                </MenuItem> */}

              </NavDropdown>

              <NavItem
                style={fontStyle}
                eventKey='/config'
                active={activeItem === "/config"}>
                <Icon name="cog" />
                {Strings.CONFIG_STRING}
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Dimmer page active={this.state.isUpdatingLanguageDimmerActive} >
          <Loader size="big">{Strings.UPDATING_LANGUAGE_WAITING}</Loader>
        </Dimmer>
      </>
    );
  }
}

const mapStateToProps = state => ({
  active: state.activeMenuItem
});

const mapActionsToProps = {
  onChangeHome: homeAction,
  onChangeResume: resumeAction,
  onChangeLiveList: livelistAction,
  onChangeLiveListMatrix: liveListMatrixAction,
  onChangeGraphicTopology: graphicTopologyAction,
  onChangeOpticFiber: opticFiberAction,
  onChangeOpticFiberLog: OpticFiberLogAction,
  onChangeTag: tagAction,
  onChangeLog: logAction,
  onChangeConfig: configAction
};

const menuStyle = {
  backgroundColor: "#262626",
  padding: "8pt",
  borderRadius: "0pt",
  borderWidth: 0
};

const fontStyle = {
  fontSize: "medium"
};

const noBorderStyle = {
  marginTop: "-4pt",
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(BootstrapMenuBar));
